import { createNotificationProvider } from '@piaas/piaas-ui-toolkit/notifications';
import { ODSInlineNotification, type ODSNotificationMode } from '@telekom-ods/react-ui-kit';
import { useIntl } from 'react-intl';

import './NotificationProvider.css';

export const { NotificationProvider: BaseNotificationProvider, useNotification } =
  createNotificationProvider({
    renderNotification: (m, { remove }) => (
      <ODSInlineNotification
        key={m.id}
        mode={m.type as ODSNotificationMode}
        title={m.title ?? ''}
        text={m.message}
        onClose={() => {
          remove(m.id);
        }}
      />
    ),
    renderContainer: notifications => <div className='notificationsDiv'>{notifications}</div>,
    useResolveMessage: () => {
      const intl = useIntl();
      return (id: string) => intl.formatMessage({ id });
    },
  });
